import { ApiBase } from '../api-base'

export class RequestsServices extends ApiBase {
  constructor() {
    super({
      resource: '/api/v1/requests',
      name: 'request',
      successPath: '/requests'
    })
  }

  /**
   * @param {Object} params
   * @param {Integer} params.employeeId
   */
  getPendingRequests(employeeId) {
    const params = {}
    if (employeeId) params.employee_id = employeeId
    const queryParams = new URLSearchParams(params)
    return this.api.get(
      `${this.resource}/pending_requests_by_employee?` + queryParams
    )
  }
}
